import { Link } from 'react-router-dom';
import NotificationsBell from '../NotificationsBell';
import FeedbackNotesButton from '../FeedbackNotesButton';
import GitHubHeaderButton from '../GitHubHeaderButton';
import { MessageQuotaChip } from '../MessageQuotaChip';
import PlatformStats from '../PlatformStats';
import HeaderMoreMenu from './HeaderMoreMenu';
import { useLanguage } from '../../context/LanguageContext';

// HeaderLogo — extraído de Header.jsx en P3.1 refactor.
// Contiene: logo de marca + chips informativos (notif, feedback, quota,
// PlatformStats). Mantiene exactamente el mismo JSX y clases que el original.
//
// 🟥 Cuadro Negro Header Mobile (feb-2026): en mobile (≤640px) los
// botones secundarios (Notif, Feedback, GitHub, Quota) se ocultan
// con `hidden sm:flex` y se acceden vía el botón "Más"
// (`HeaderMoreMenu`) — el cual es `flex sm:hidden`. El botón
// `genio-open` y el logo permanecen siempre visibles para que en
// iPhone 14 todo entre en la fila sin overflow horizontal.
const HeaderLogo = ({ isLoggedIn, activeProjectFiles = [] }) => {
  const { language } = useLanguage();
  return (
  <div className="flex items-center gap-1 sm:gap-4 flex-shrink-0">
    <Link to="/" className="flex items-center gap-2 group">
      <span className="text-base sm:text-xl font-bold bg-gradient-to-r from-sky-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
        DamyxIA
      </span>
    </Link>

    {/* 🟪 P25.4 · Menú "Más" (3 puntos) — visible SOLO en mobile.
        Se mantiene FIJO en el header (fuera del scroll horizontal
        introducido en P25.6). Orden vertical: GitHub → Agenda →
        Notificaciones → Quota. */}
    {isLoggedIn && (
      <HeaderMoreMenu>
        <div data-testid="header-more-menu-item-github" className="rounded-md hover:bg-[#1a1a1a] transition-colors">
          <GitHubHeaderButton projectFiles={activeProjectFiles} language={language} />
        </div>
        <div data-testid="header-more-menu-item-agenda" className="rounded-md hover:bg-[#1a1a1a] transition-colors">
          <FeedbackNotesButton />
        </div>
        <div data-testid="header-more-menu-item-notifications" className="rounded-md hover:bg-[#1a1a1a] transition-colors">
          <NotificationsBell />
        </div>
        <div data-testid="header-more-menu-item-quota" className="rounded-md hover:bg-[#1a1a1a] transition-colors">
          <MessageQuotaChip />
        </div>
      </HeaderMoreMenu>
    )}

    {/* Botones secundarios — visibles SOLO en desktop (≥640px),
        ocultos en mobile porque se acceden desde el menú ⋮ de arriba. */}
    {isLoggedIn && (
      <div className="hidden sm:flex items-center gap-1 sm:gap-2">
        <NotificationsBell />
        <FeedbackNotesButton />
        <GitHubHeaderButton projectFiles={activeProjectFiles} language={language} />
      </div>
    )}

    {/* Platform Stats - Admin only, desktop */}
    <div className="hidden md:block">
      {isLoggedIn && <PlatformStats />}
    </div>

    {/* 🟪 P25.6 · Genio, DeviceSwitch y Refresh se MOVIERON a la
        zona con scroll horizontal en Header.jsx (para mobile/tablet).
        En desktop siguen visibles allí en la misma línea. NO se
        borraron — solo cambiaron de contenedor. */}
  </div>
  );
};

export default HeaderLogo;
